$(function () {
  // 初期化
  sortable()
  let sectionHtml = $('.formSectionField:last').prop("outerHTML");
  let questionHtml = $('.formQuestionField:last').prop("outerHTML");
  let selectElementHtml = $('.formQuestionSelectElementField:last').prop("outerHTML");
  
  if (/common_forms\/\d+\/edit/.test(location.pathname)) {
    $('.formSectionField:last').remove(); // form.form_sections.build → 追加用のhtmlとして保持 → form自体は不要なのでここで削除
    sectionHtml = sectionHtml.replace(/\[form_sections_attributes\]\[\d+\]/g, "[form_sections_attributes][0]")
                             .replace(/form_sections_attributes_\d+/g, "form_sections_attributes_0");
    questionHtml = questionHtml.replace(/\[form_sections_attributes\]\[\d+\]/g, "[form_sections_attributes][0]")
                               .replace(/form_sections_attributes_\d+/g, "form_sections_attributes_0");
    selectElementHtml = selectElementHtml.replace(/\[form_sections_attributes\]\[\d+\]/g, "[form_sections_attributes][0]")
                                         .replace(/form_sections_attributes_\d+/g, "form_sections_attributes_0");
  }

  let addSectionBtn = ".addFormSection";
  let addSectionAddressBtn = ".addFormSectionAddress";
  let removeSectionBtn  = ".removeFormSection";
  let sectionCnt = $(".formSectionField").length;
  let lastSectionNo = sectionCnt - 1;
  let addSectionHtml;
  let sectionNo;
  let input_type = {
    "radio_button": 0,
    "pulldown": 1,
    "check_box": 2,
    "text_field": 3,
    "text_area": 4,
    "zip1": 5,
    "zip2": 6,
    "prefecture": 7,
    "address1": 8,
    "address2": 9,
    "last_name": 10,
    "first_name": 11,
    "tel": 12,
    "date": 13,
    "last_name_2": 14,
    "first_name_2": 15
  };
  let addressQuestionTitles = [
    ["姓", input_type["last_name"], {"readonly": true}],
    ["名", input_type["first_name"], {"readonly": true}],
    ["郵便番号1", input_type["zip1"], {"readonly": true}],
    ["郵便番号2", input_type["zip2"], {"readonly": true}],
    ["都道府県", input_type["prefecture"], {"readonly": true}],
    ["市区町村", input_type["address1"], {"readonly": true}],
    ["番地以降", input_type["address2"], {"readonly": true}],
    ["電話番号", input_type["tel"], {"readonly": true}]
  ];
  let readonlyType = addressQuestionTitles.map(x => { if (x[2]["readonly"]){ return x[1] }}).filter(Boolean);
  let addQuestionBtn = ".addFormQuestion";
  let copyQuestionBtn = ".copyFormQuestion";
  let removeQuestionBtn  = ".removeFormQuestion";
  let questionCnt;
  let lastQuestionNo = {};
  let addQuestionHtml;
  let copyQuestionHtml;
  let sectionFieldId;
  let sectionField
  let questionNo;
  let questionTitle;
  let questionInputType;
  let questionIsRequired;
  let questionIsCounted;
  let questionIsClickedAppear;
  let questionClickedAppearText;
  let questionClickedAppearGroup;
  let questionClickedAppearSubgroup;
  let addedQuestion;
  let questionSelectElemnts;
  let questionHiddenId;

  let inputTypeWrapper = ".formQuestionInputTypeWrapper"
  let selecElementsWrapper = ".formQuestionSelecElementsWrapper"
  let selectElement = ".formQuestionSelectElement"
  let addSelectElementBtn = ".addSelectElement";
  let addSelectElementHtml;
  let questionFieldId;
  let sectionQuestionNo;
  let lastSelectElementNo = {};
  let selectElementNo;
  let removeSelectElementBtn = ".removeFormQuestionSelectElement"
  let selectElementCnt;
  let nextOrderVal;
  let maxCountWrapper = ".selectElementMaxCountWrapper";

  let sectionMaxCnt = 15;
  let selectElementMaxCnt = 20;
  let questionMaxCnt = 20;

  let addOtherBtn = ".addSelectElementOther"
  if (sectionCnt >= sectionMaxCnt) {
    $(addSectionBtn).hide();
    $(addSectionAddressBtn).hide();
  }

  $(".formSectionField").each(function(i, section){
    $(section).attr("id", `formSectionFieldNo${i}`);
    $(section).find(".formQuestionField").each(function(j, question){
      selectElementCnt = $(question).find(".formQuestionSelectElementField").length;
      $(question).attr("id", `formQuestionFieldNo${i}-${j}`);
      lastSelectElementNo[`formQuestionFieldNo${i}-${j}`] = selectElementCnt - 1
      if (selectElementCnt >= selectElementMaxCnt) {
        $(question).find(addSelectElementBtn).hide();
      }
      // 記述式(短文):3, 記述式(長文):4, 住所関連の場合はaddSelectElementBtnを隠す
      let num = Number($(question).find(".formQuestionInputType").val());
      if ( num >= 3 ){
        $(question).find(addSelectElementBtn ).hide();
      }
      // プルダウン:1, 記述式(短文):3, 記述式(長文):4, 住所関連の場合はaddOtherBtnを隠す
      if ( num >= 3 || num == 1) {
        $(question).find(addOtherBtn).hide();
      }
      // ラジオボタン以外はmax_count入力欄を隠す
      if ( num >= 1 ) {
        $(question).find(maxCountWrapper).hide();
      }
      sortSelectElement(question);
    });
    sortFormQuestion(section);
    questionCnt = $(section).find(".formQuestionField").length;
    lastQuestionNo[`formSectionFieldNo${i}`] = questionCnt - 1;
    if (questionCnt >= questionMaxCnt) {
      $(section).find(addQuestionBtn).hide();
    }
  });
  sortFormSection()

  $(".formQuestionField").each(function(i, question){
    let inputTypeVal = Number($(question).find(".formQuestionInputType").val());
    if (readonlyType.includes(inputTypeVal)) {
      $(question).find(".questionTitle").attr('readonly', true);
    }
  });

  // form_section

  $(addSectionBtn).click(function () {
    sectionCnt = $(".formSectionField").length;
    lastSectionNo++;
    addSectionHtml = sectionHtml.replace(/\[form_sections_attributes\]\[0\]/g, "[form_sections_attributes][" + lastSectionNo + "]")
                                .replace(/form_sections_attributes_0/g, "form_sections_attributes_" + lastSectionNo);
    if (sectionCnt > 0) {
      nextOrderVal = Number($('.formSectionField:last').find(".formSectionOrder").val()) + 1
      $('.formSectionField:last').after(addSectionHtml);
      $('.formSectionField:last').find(".formSectionOrder").val(nextOrderVal)
    } else {
      $('.formSectionsWrapper').append(addSectionHtml);
    }
    $(".formSectionField:last").attr("id", `formSectionFieldNo${lastSectionNo}`);
    lastQuestionNo[`formSectionFieldNo${lastSectionNo}`] = 0;
    $(".formSectionField:last").find(".formQuestionField").each(function(index, question){
      $(question).attr("id", `formQuestionFieldNo${lastSectionNo}-${index}`);
      lastSelectElementNo[`formQuestionFieldNo${lastSectionNo}-${index}`] = 0;
    });
    if (sectionCnt >= sectionMaxCnt - 1) {
      $(addSectionBtn).hide();
      $(addSectionAddressBtn).hide();
    }
    sortable();
  });

  // 住所入力用 form_section追加

  $(addSectionAddressBtn).click(function () {
    $(addSectionBtn).trigger('click');
    sectionField = $(".formSectionField:last");
    sectionField.find(".sectionTitle").val("お届け先情報");
    addressQuestionTitles.forEach(function(elem, i) {
      sectionField.find(".formQuestionField:last").find(".questionTitle").val(elem[0]);
      sectionField.find(".formQuestionField:last").find(".questionTitle").attr('readonly', elem[2]["readonly"]);
      sectionField.find(".formQuestionField:last").find(".formQuestionInputType").val(elem[1]);
      sectionField.find(".formQuestionField:last").find(inputTypeWrapper).trigger('change');
      sectionField.find(".questionIsRequired").prop('checked', true);
      if (i < addressQuestionTitles.length - 1) {
        sectionField.find(addQuestionBtn).trigger('click');
      }
    });
  });

  $(document).on('click', removeSectionBtn, function() {
    $(this).parent().remove();
    $(addSectionBtn).show();
    $(addSectionAddressBtn).show();
  });

  // form_question

  $(document).on('click', addQuestionBtn, function() {
    sectionFieldId = $(this).parent().attr("id")
    sectionNo = sectionFieldId.replace(/formSectionFieldNo/g, '')
    lastQuestionNo[sectionFieldId]++;
    questionNo = lastQuestionNo[sectionFieldId];
    addQuestionHtml = questionHtml.replace(/\[form_sections_attributes\]\[0\]/g, "[form_sections_attributes][" + sectionNo + "]")
                                  .replace(/form_sections_attributes_0/g, "form_sections_attributes_" + sectionNo)
                                  .replace(/\[form_questions_attributes\]\[0\]/g, "[form_questions_attributes][" + questionNo + "]")
                                  .replace(/form_questions_attributes_0/g, "form_questions_attributes_" + questionNo);

    questionCnt = $(this).parent().find(".formQuestionField").length;
    if (questionCnt > 0) {
      nextOrderVal = Number($(this).parent().find(".formQuestionField:last").find(".formQuestionOrder").val()) + 1
      $(this).parent().find(".formQuestionField:last").after(addQuestionHtml);
      $(this).parent().find(".formQuestionField:last").find(".formQuestionOrder").val(nextOrderVal)
    } else {
      $(this).parent().find(".formQuestionsWrapper").append(addQuestionHtml);
    }
    $(this).parent().find(".formQuestionField:last").attr("id", `formQuestionFieldNo${sectionNo}-${questionNo}`);
    lastSelectElementNo[`formQuestionFieldNo${sectionNo}-${questionNo}`] = 0;
    if (questionCnt >= questionMaxCnt - 1) {
      $(this).parent().find(addQuestionBtn).hide();
    }
    sortable();
  });

  $(document).on('click', removeQuestionBtn, function() {
    $(this).parent().parent().parent().find(addQuestionBtn).show();
    $(this).parent().remove();
  });

  // コピー機能
  $(document).on('click', copyQuestionBtn, function() {
    sectionField = $(this).parent().parent().parent()
    sectionFieldId = sectionField.attr("id")
    sectionNo = sectionFieldId.replace(/formSectionFieldNo/g, '')
    lastQuestionNo[sectionFieldId]++;
    questionNo = lastQuestionNo[sectionFieldId];
    copyQuestionHtml = $(this).parent().prop("outerHTML");
    addQuestionHtml = copyQuestionHtml.replace(/\[form_questions_attributes\]\[\d+\]/g, "[form_questions_attributes][" + questionNo + "]")
                                      .replace(/form_questions_attributes_\d+/g, "form_questions_attributes_" + questionNo)
                                      .replace(/<input type="hidden" value="\d+" name="form\[form_sections_attributes\]\[\d+\]\[form_questions_attributes\]\[\d+\]\[form_question_select_elements_attributes\]\[\d+\]\[id\]" id="form_form_sections_attributes_\d+_form_questions_attributes_\d+_form_question_select_elements_attributes_\d+_id" style="">/g, "");
    questionCnt = sectionField.find(".formQuestionField").length;
    if (questionCnt > 0) {
      nextOrderVal = Number(sectionField.find(".formQuestionField:last").find(".formQuestionOrder").val()) + 1
      sectionField.find(".formQuestionField:last").after(addQuestionHtml);
      sectionField.find(".formQuestionField:last").find(".formQuestionOrder").val(nextOrderVal)
    } else {
      sectionField.find(".formQuestionsWrapper").append(addQuestionHtml);
    }
    sectionField.find(".formQuestionField:last").attr("id", `formQuestionFieldNo${sectionNo}-${questionNo}`);
    lastSelectElementNo[`formQuestionFieldNo${sectionNo}-${questionNo}`] = 0;
    if (questionCnt >= questionMaxCnt - 1) {
      sectionField.find(addQuestionBtn).hide();
    }

    // editの場合既存のform_questionはform_question.idの値がinput hidden要素で含まれている。
    // コピーした時にform_question.idの値もコピーされ、DB保存時にエラーとなるのでここで削除する。
    sectionField.find(".formQuestionField:last").find(selecElementsWrapper).find(".formQuestionSelectElement").each(function(i, elem) {
      questionHiddenId = "#" + $(elem).attr("id").replace(/title/g, "id");
      sectionField.find(".formQuestionField:last").find(selecElementsWrapper).find(questionHiddenId).remove()
    });

    sortable();

    // 各値のコピー
    questionTitle = $(this).parent().find(".questionTitle").val();
    questionInputType = $(this).parent().find(".formQuestionInputType").val();
    questionIsRequired = $(this).parent().find(".questionIsRequired ").prop('checked');
    questionIsCounted = $(this).parent().find(".questionIsCounted ").prop('checked');
    questionIsClickedAppear = $(this).parent().find(".questionIsClickedAppear").prop('checked');
    questionClickedAppearText = $(this).parent().find(".questionClickedAppearText").val();
    questionClickedAppearGroup = $(this).parent().find(".questionClickedAppearGroup").val();
    questionClickedAppearSubgroup = $(this).parent().find(".questionClickedAppearSubgroup").val();

    questionSelectElemnts = [];
    $(this).parent().find(".formQuestionSelectElementField").each(function(i, elem) {
      questionSelectElemnts.push($(elem).find(".formQuestionSelectElement").val());
    });
    addedQuestion = sectionField.find(".formQuestionField:last");
    addedQuestion.find(".questionTitle").val(questionTitle);
    addedQuestion.find(".formQuestionInputType").val(questionInputType);
    addedQuestion.find(".questionIsRequired").prop('checked', questionIsRequired);
    addedQuestion.find(".questionIsCounted").prop('checked', questionIsCounted);
    addedQuestion.find(".questionIsClickedAppear").prop('checked', questionIsClickedAppear);
    addedQuestion.find(".questionClickedAppearText").val(questionClickedAppearText);
    addedQuestion.find(".questionClickedAppearGroup").val(questionClickedAppearGroup);
    addedQuestion.find(".questionClickedAppearSubgroup").val(questionClickedAppearSubgroup);
    addedQuestion.find(".formQuestionSelectElementField").each(function(i, elem) {
      $(elem).find(".formQuestionSelectElement").val(questionSelectElemnts[i]);
    });
  });

  // form_question_select_element

  $(document).on("change", inputTypeWrapper, function() {
    // ラジオボタン:0, プルダウン:1, チェックボックス:2, 記述式(短文):3, 記述式(長文):4
    if (["0","1","2"].includes($(this).find(".formQuestionInputType").val())){
      $(this).parent().find(selecElementsWrapper).show();
      if ($(this).parent().find(selectElement).length == 0) {
        $(this).parent().find(addSelectElementBtn).trigger('click');
      }
    } else {
      $(this).parent().find(selecElementsWrapper).hide();
      $(this).parent().find(".formQuestionSelectElementField").each(function(i, elem){
        $(elem).remove();
      });
    }
    // ラジオボタン:0, チェックボックス:2はその他追加ボタン表示
    if (["0","2"].includes($(this).find(".formQuestionInputType").val())) {
      $(this).parent().find(addOtherBtn).show();
    } else {
      $(this).parent().find(addOtherBtn).hide();
    }
    // 住所関連はタイトルを自動入力
    let val = Number($(this).find(".formQuestionInputType").val());
    if ( 5 <= val && val <= 12 ) {
      let elem = addressQuestionTitles.find(x => x[1] == val)
      $(this).parent().find(".questionTitle").val(elem[0]);
      $(this).parent().find(".questionTitle").attr('readonly', elem[2]["readonly"]);
      $(this).parent().find(".questionIsRequired").prop('checked', true);
    }
    // ラジオボタン以外はmax_count入力欄を隠す
    if ( val >= 1 ) {
      $(this).parent().find(maxCountWrapper).find(".selectElementMaxCount").val("");
      $(this).parent().find(maxCountWrapper).hide();
    } else {
      $(this).parent().find(maxCountWrapper).show();
    }
  });

  $(document).on('click', addSelectElementBtn, function() {
    questionFieldId = $(this).parent().parent().attr("id");
    sectionQuestionNo = questionFieldId.replace(/formQuestionFieldNo/g, '').split("-");
    sectionNo = sectionQuestionNo[0];
    questionNo = sectionQuestionNo[1];
    lastSelectElementNo[questionFieldId]++;
    selectElementNo = lastSelectElementNo[questionFieldId]
    addSelectElementHtml = selectElementHtml.replace(/\[form_sections_attributes\]\[0\]/g, "[form_sections_attributes][" + sectionNo + "]")
                                            .replace(/form_sections_attributes_0/g, "form_sections_attributes_" + sectionNo)
                                            .replace(/\[form_questions_attributes\]\[0\]/g, "[form_questions_attributes][" + questionNo + "]")
                                            .replace(/form_questions_attributes_0/g, "form_questions_attributes_" + questionNo)
                                            .replace(/\[form_question_select_elements_attributes\]\[0\]/g, "[form_question_select_elements_attributes][" + selectElementNo + "]")
                                            .replace(/form_question_select_elements_attributes_0/g, "form_question_select_elements_attributes_" + selectElementNo);
    selectElementCnt = $(this).parent().find(".formQuestionSelectElementField").length;
    if (selectElementCnt > 0) {
      nextOrderVal = Number($(this).parent().parent().find(".formQuestionSelectElementField:last").find(".selectElementOrder").val()) + 1
      $(this).parent().parent().find(".formQuestionSelectElementField:last").after(addSelectElementHtml);
      $(this).parent().parent().find(".formQuestionSelectElementField:last").find(".selectElementOrder").val(nextOrderVal)
    } else {
      $(this).before(addSelectElementHtml);
    }
    if (selectElementCnt >= selectElementMaxCnt - 1) {
      $(this).parent().parent().find(addSelectElementBtn).hide();
    }
    // ラジオボタン以外はmax_count入力欄を隠す
    let val = Number($(this).parent().parent().find(".formQuestionInputType").val());
    if ( val >= 1 ) {
      $(this).parent().parent().find(maxCountWrapper).hide();
    }    
    sortable();
  });

  $(document).on('click', addOtherBtn, function() {
    questionFieldId = $(this).parent().parent().attr("id");
    sectionQuestionNo = questionFieldId.replace(/formQuestionFieldNo/g, '').split("-");
    sectionNo = sectionQuestionNo[0];
    questionNo = sectionQuestionNo[1];
    lastSelectElementNo[questionFieldId]++;
    selectElementNo = lastSelectElementNo[questionFieldId]
    addSelectElementHtml = selectElementHtml.replace(/\[form_sections_attributes\]\[0\]/g, "[form_sections_attributes][" + sectionNo + "]")
                                            .replace(/form_sections_attributes_0/g, "form_sections_attributes_" + sectionNo)
                                            .replace(/\[form_questions_attributes\]\[0\]/g, "[form_questions_attributes][" + questionNo + "]")
                                            .replace(/form_questions_attributes_0/g, "form_questions_attributes_" + questionNo)
                                            .replace(/\[form_question_select_elements_attributes\]\[0\]/g, "[form_question_select_elements_attributes][" + selectElementNo + "]")
                                            .replace(/form_question_select_elements_attributes_0/g, "form_question_select_elements_attributes_" + selectElementNo);
    selectElementCnt = $(this).parent().find(".formQuestionSelectElementField").length;
    if (selectElementCnt > 0) {
      nextOrderVal = Number($(this).parent().parent().find(".formQuestionSelectElementField:last").find(".selectElementOrder").val()) + 1
      $(this).parent().parent().find(".formQuestionSelectElementField:last").after(addSelectElementHtml);
      $(this).parent().parent().find(".formQuestionSelectElementField:last").find(".selectElementOrder").val(nextOrderVal)
    } else {
      $(this).before(addSelectElementHtml);
    }
    if (selectElementCnt >= selectElementMaxCnt - 1) {
      $(this).parent().parent().find(addSelectElementBtn).hide();
    }
    $(this).parent().parent().find(".formQuestionSelectElementField:last").find(selectElement).val("その他")
    // ラジオボタン以外はmax_count入力欄を隠す
    let val = Number($(this).parent().parent().find(".formQuestionInputType").val());
    if ( val >= 1 ) {
      $(this).parent().parent().find(maxCountWrapper).hide();
    }
    sortable();
  });

  $(document).on('click', removeSelectElementBtn, function() {
    $(this).parent().parent().parent().find(addSelectElementBtn).show();
    $(this).parent().parent().remove();
  });

  function sortable() {
    $(".sortableSelecElements").sortable({
      "cancel":".unsoartable",
      "handle":".sortHandle",
      update: function(event, ui) {
        // orderの値を反映
        $(event.target).find(".formQuestionSelectElementField").each(function(index, field){
          $(field).find(".selectElementOrder").val(index);
        });
      }
    });

    $(".sortableFormQuestions").sortable({
      "cancel":".unsoartable",
      "handle":".sortHandle",
      update: function(event, ui) {
        // orderの値を反映
        $(event.target).find(".formQuestionField").each(function(index, field){
          $(field).find(".formQuestionOrder").val(index);
        });
      }
    });

    $(".sortableFormSections").sortable({
      "cancel":".unsoartable",
      "handle":".sortHandle",
      update: function(event, ui) {
        // orderの値を反映
        $(event.target).find(".formSectionField").each(function(index, field){
          $(field).find(".formSectionOrder").val(index);
        });
      }
    });
  };

  function sortSelectElement(question) {
    $(question).find(".formQuestionSelectElementField").sort((a,b) => {
      if (Number($(a).find(".selectElementOrder").val()) >= Number($(b).find(".selectElementOrder").val())) {
        return 1;
      } else {
        return -1;
      }
    }).appendTo($(question).find(selecElementsWrapper));
  };

  function sortFormQuestion(section) {
    $(section).find(".formQuestionField").sort((a,b) => {
      if (Number($(a).find(".formQuestionOrder").val()) >= Number($(b).find(".formQuestionOrder").val())) {
        return 1;
      } else {
        return -1;
      }
    }).appendTo($(section).find(".formQuestionsWrapper"));
  };

  function sortFormSection() {
    $(".formSectionField").sort((a,b) => {
      if (Number($(a).find(".formSectionOrder").val()) >= Number($(b).find(".formSectionOrder").val())) {
        return 1;
      } else {
        return -1;
      }
    }).appendTo($(".formSectionsWrapper"));
  };
});
